// extracted by css-extract-rspack-plugin
export default {"cls1":"FilterToggle-cls1_FJ1","cls2":"FilterToggle-cls2_vlx FilterToggle-cls1_FJ1","mobileLayout":"FilterToggle-mobileLayout_LF_"};